
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-body">
        <label>The Sold-To results are restricted to the Deployment Country. If you are onboarding a contract with Local to Central invoicing model and you need a Sold-To in a different country, please select the check box and this will open your search to all the countries where a Sold-To with that name has a BPID created.</label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="cancel()">OK</button>
      </div>
    </form>
  </div>
</div>